/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PrefabInputs */

const cs_enum_prefab = /** @type {(inputs: Enum_PrefabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montovaná`)
};

const en_enum_prefab = /** @type {(inputs: Enum_PrefabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefab`)
};

/**
* | output |
* | --- |
* | "Prefab" |
*
* @param {Enum_PrefabInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_prefab = /** @type {((inputs?: Enum_PrefabInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PrefabInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_prefab(inputs)
	return cs_enum_prefab(inputs)
});